module.exports = "/_next/static/images/andhra_nan-d53baae285b7e42bb59181ea260b3e41.jpg";